import { CategoryType } from '@/libs/types'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

interface CategoriesProps {
    locale: string
    categories: Array<CategoryType>,
    active?: CategoryType
}
const Categories: React.FC<CategoriesProps> = ({
    locale,
    active,
    categories = []
}) => {
    if (categories.length === 0) return <></>;
    return (
        <div className="container mb-3 categories">
            {categories.length !== 0 && (
                <div className='row'>
                    <div className='d-flex justify-content-center col-12'>
                        {categories.map(({ attributes, id }: CategoryType, index: number) => {
                            if (attributes.posts.data.length === 0) return <></>
                            return (
                                <Link key={index}
                                    href={`/${locale}/news/category/${attributes?.slug}`}
                                    className={clsx(id === active?.id ? "active" : "text-muted", "p-2 category")}
                                    passHref>
                                    {attributes.name}
                                </Link>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Categories